import React from "react";
import { PhoneButton, PHONE } from "./PhoneButton";

export const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-20 md:py-28 bg-blue-900 overflow-hidden"
    >
      {/* decorative grid */}
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-amber-400/20 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-green-400/20 blur-3xl" />

      <div className="relative mx-auto max-w-5xl px-6 md:px-12 text-center">
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] font-semibold text-amber-300">
          Ready to Save?
        </p>
        <h2
          data-testid="final-cta-heading"
          className="font-serif-display mt-4 text-4xl md:text-6xl font-bold leading-tight tracking-tight text-white"
        >
          Call now — a licensed agent is standing by.
        </h2>
        <p className="mt-6 text-xl md:text-2xl text-blue-100 leading-relaxed max-w-3xl mx-auto">
          Free quote. No obligation. No medical exam. Find out in minutes how
          affordable life insurance can be on a fixed income.
        </p>

        <div className="mt-10 flex flex-col items-center gap-4">
          <PhoneButton
            size="xl"
            testId="final-cta-call-button"
            label={PHONE.display}
            className="shadow-2xl shadow-black/30"
          />
          <p
            data-testid="final-cta-subline"
            className="text-base md:text-lg text-blue-200"
          >
            Or dial{" "}
            <a
              href={PHONE.href}
              className="underline underline-offset-4 font-semibold text-white"
            >
              +1 {PHONE.display}
            </a>{" "}
            from any phone
          </p>
        </div>
      </div>
    </section>
  );
};
